/* eslint-disable max-len */
import React from 'react';

const defaultTitle = 'Salesforce Logo';
const defaultColor = '#1890FF';

export interface SalesforceLogoProps {
	color?: string;
	title?: string;
}

export const SalesforceLogo: React.FC<SalesforceLogoProps> = ({ color = defaultColor, title = defaultTitle }) =>
	<svg
		className='salesforce-logo'
		fill='none'
		height='24'
		viewBox='0 0 24 24'
		width='24'
		xmlns='http://www.w3.org/2000/svg'>
		<title>{ title }</title>
		<path
			d='m10.3685 7.03551c.6526-.65259 1.5355-1.07486 2.5336-1.07486 1.3052 0 2.4568.72937 3.071 1.80423.5375-.23033 1.1133-.38388 1.7275-.38388 2.38 0 4.2994 1.91938 4.2994 4.2994 0 2.3801-1.9194 4.2994-4.2994 4.2994-.3071 0-.5758-.0383-.8446-.0767-.5374.9597-1.5739 1.6123-2.7639 1.6123-.499 0-.9597-.1152-1.3819-.3071-.5375 1.2667-1.8042 2.1497-3.30137 2.1497-1.53551 0-2.87908-.9597-3.37812-2.3417-.23033.0384-.46065.0768-.69098.0768-1.84261 0-3.33973-1.4971-3.33973-3.3397 0-1.2284.65259-2.3033 1.65067-2.8791-.19194-.4607-.3071-.9981-.3071-1.53553 0-2.11132 1.72745-3.83877 3.87716-3.83877 1.34357.03839 2.45681.6142 3.14777 1.53551z'
			fill={ color } />
	</svg>;
